import { render, staticRenderFns } from "./EdimensajeauditoriaGrid.vue?vue&type=template&id=e35d6188"
import script from "./EdimensajeauditoriaGrid.vue?vue&type=script&lang=js"
export * from "./EdimensajeauditoriaGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports